import React, { Component } from "react";
import client from "@culturehq/client";
import { CentsField, Form, ModalDialog, StringField, SubmitButton } from "@culturehq/components";

import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalDialog from "components/common/ChqModalDialog";

const ExpenseForm = ({ onSubmit, expense: { amount, description }, isEdit }) => {
  const submitText = isEdit ? t("Update Expense") : t("Add Expense");

  return (
    <Form onSubmit={onSubmit} initialValues={{ amount, description }}>
      <CentsField name="amount" required>Amount</CentsField>
      <StringField name="description" required>Description</StringField>
      <SubmitButton primary fillParent>
        {submitting => (submitting ? t("Submitting...") : submitText)}
      </SubmitButton>
    </Form>
  );
};

class ExpenseModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expense: props.expense || { amount: 0, description: "" },
      error: false,
      open: false
    };
  }

  handleClose = () => {
    this.setState({ open: false, error: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleSubmit = async values => {
    const { event: { id: eventId }, onUpdate } = this.props;
    const { expense } = this.state;
    const options = { ...values, eventId };

    try {
      this.setState({ error: false });

      if (expense && expense.id) {
        await client.updateExpense({ ...options, expenseId: expense.id });
      } else {
        await client.createExpense(options);
      }

      this.setState({ error: false, open: false });
      onUpdate(true);
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    const { children } = this.props;
    const { error, expense, open } = this.state;

    return (
      <>
        {children(this.handleOpen)}
        {open && (
          <ChqModalDialog onClose={this.handleClose} width="narrow">
            <ModalDialog.Heading onClose={this.handleClose}>
              <Trans>Event Expense</Trans>
            </ModalDialog.Heading>
            <ModalDialog.Body>
              {error && <ErrorMessage error={error} />}

              <ExpenseForm
                expense={expense}
                onSubmit={this.handleSubmit}
                isEdit={expense.id}
              />
            </ModalDialog.Body>
          </ChqModalDialog>
        )}
      </>
    );
  }
}

export default ExpenseModal;
